import MediaBodyCopyComponent from './component'
export default MediaBodyCopyComponent
